import { render, staticRenderFns } from "./SolutionPage.vue?vue&type=template&id=0268850c&scoped=true"
import script from "./SolutionPage.vue?vue&type=script&lang=js"
export * from "./SolutionPage.vue?vue&type=script&lang=js"
import style0 from "./SolutionPage.vue?vue&type=style&index=0&id=0268850c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268850c",
  null
  
)

export default component.exports